import {getPreparedImageToUploading} from 'helpers/getPreparedImageForUploading';
import ApiManager, {RequestType, UploadFileType} from '../ApiManager';
import fileUploader from '../FileUploader';
import {CurrentUserResponse} from './UsersApiModels';

export interface IUsersApiManager {
  getCurrentUser: () => Promise<CurrentUserResponse>;
  deleteUser: (userId: string) => Promise<void>;
  changePhoto: (image?: string) => Promise<void>;
  deletePhoto: () => Promise<void>; 
}

export default class UsersApiManager implements IUsersApiManager {
  getCurrentUser = () => {
    return ApiManager.request<CurrentUserResponse>(RequestType.currentUser, {});
  };

  deleteUser = (userId: string) => {
    return ApiManager.request<void>(RequestType.deleteUser, {query: userId});
  };

  changePhoto = (image?: string) => {
    let formattedPhoto = getPreparedImageToUploading(image);
    let data = new FormData();
    data.append('photo', {
      //@ts-ignore
      uri: formattedPhoto.uri,
      type: formattedPhoto.type,
      name: formattedPhoto.name,
    });

    return fileUploader.uploadFile<void>(RequestType.changePhoto, data);
  };

  changePhotoWeb = (image?: File) => {
    let data = new FormData();
    image && data.append('photo', image);

    return fileUploader.uploadFile<void>(RequestType.changePhoto, data);
  };

  deletePhoto = () => {
    return ApiManager.request<void>(RequestType.deletePhoto, {});
  };
}
